<section [fxLayout]="displayMode() === 'default' ? 'row' : 'column'" fxLayoutGap="20px" fxLayoutAlign="start stretch">
  @if (site(); as site) {
    <div [fxFlex]="displayMode() === 'default' ? '50%' : '100%'" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="16px">
      <div fxLayout="row wrap" fxFlex="1 1 auto">
        <span (click)="selectSite.emit(site)" class="mve-detail-popup-title fw-600 mve-detail-popup-title-clickable">{{ site.name }}</span>
      </div>

      <div fxFlex="0 0 auto" fxLayoutAlign="end center">
        <ng-content select="[headerAction]" />
      </div>
    </div>

    <div [fxFlex]="displayMode() === 'default' ? '50%' : '100%'" fxLayout="column">
      <iot-platform-ui-detail-popup-display-property
        property="{{ 'SITES.CARD.TYPE' | translate }}:"
        value="{{ 'SITES.CARD.TYPES.' + site.type | infoDisplay | translate }}"
      />
      @if (site.type !== SiteType.MOBILE_FLEET) {
        <iot-platform-ui-detail-popup-display-property property="{{ 'SITES.CARD.CUSTOMER_NUMBER' | translate }}:" value="{{ site.customerNumber | infoDisplay }}" />
        <iot-platform-ui-detail-popup-display-property
          property="{{ 'SITES.INFO_FORM.ADDRESS_1' | translate }}:"
          value="{{ site.address.address1 | infoDisplay }}"
        />
        <iot-platform-ui-detail-popup-display-property
          property="{{ 'SITES.INFO_FORM.ADDRESS_2' | translate }}:"
          value="{{ site.address.address2 | infoDisplay }}"
        />
        <iot-platform-ui-detail-popup-display-property property="{{ 'SITES.INFO_FORM.CITY' | translate }}:" value="{{ site.address.city | infoDisplay }}" />
        @if (site.address.country) {
          <iot-platform-ui-detail-popup-display-property
            property="{{ 'SITES.INFO_FORM.COUNTRY' | translate }}:"
            value="{{ 'SITES.CARD.COUNTRIES.' + site.address.country | translate }}"
          />
        }
      }
    </div>
  }
</section>
